import { combineReducers } from 'redux';
import { userReducer } from 'users/reducers';
import analyticsUsers from 'analytics/reducers';

const rootReducer = combineReducers({
  LEARNERSDATA: analyticsUsers,
  USERSDATA: userReducer.fetchUsers,
  COURSES: userReducer.fetchCourses,
  LOGGEDINUSER: userReducer.fetchLoggedInUsers,
  USER_SEARCH_OPTIONS: userReducer.fetchUserSearchOptions,
});

export default rootReducer;
